'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint max-len: [0] */


var IconCopy = function IconCopy(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color, transform: 'translate(4, 2)' },
      _react2.default.createElement('path', { d: 'M10.968,19.576 C10.744,19.576 10.568,19.4 10.568,19.176 L10.568,15 C10.568,14.776 10.744,14.6 10.968,14.6 L15.144,14.6 C15.368,14.6 15.544,14.776 15.544,15 C15.544,15.224 15.368,15.4 15.144,15.4 L11.368,15.4 L11.368,19.176 C11.368,19.4 11.192,19.576 10.968,19.576', id: 'Fill-2095' }),
      _react2.default.createElement('path', { d: 'M4.568,18.376 L10.64,18.376 L14.344,14.672 L14.344,5.68 L4.568,5.68 L4.568,18.376 Z M10.968,19.976 L3.768,19.976 C3.328,19.976 2.968,19.624 2.968,19.176 L2.968,4.88 C2.968,4.44 3.328,4.08 3.768,4.08 L15.144,4.08 C15.592,4.08 15.944,4.44 15.944,4.88 L15.944,15 C15.944,15.216 15.864,15.416 15.712,15.568 L11.536,19.744 C11.384,19.896 11.184,19.976 10.968,19.976 L10.968,19.976 Z', id: 'Fill-2096' }),
      _react2.default.createElement('path', { d: 'M10.216,7.92 L6.12,7.92 C5.904,7.92 5.72,7.744 5.72,7.52 C5.72,7.304 5.904,7.12 6.12,7.12 L10.216,7.12 C10.432,7.12 10.616,7.304 10.616,7.52 C10.616,7.744 10.432,7.92 10.216,7.92', id: 'Fill-2097' }),
      _react2.default.createElement('path', { d: 'M12.912,10.032 L6.12,10.032 C5.904,10.032 5.72,9.848 5.72,9.632 C5.72,9.408 5.904,9.232 6.12,9.232 L12.912,9.232 C13.136,9.232 13.312,9.408 13.312,9.632 C13.312,9.848 13.136,10.032 12.912,10.032', id: 'Fill-2098' }),
      _react2.default.createElement('path', { d: 'M12.912,12.136 L6.12,12.136 C5.904,12.136 5.72,11.952 5.72,11.736 C5.72,11.512 5.904,11.336 6.12,11.336 L12.912,11.336 C13.136,11.336 13.312,11.512 13.312,11.736 C13.312,11.952 13.136,12.136 12.912,12.136', id: 'Fill-2099' }),
      _react2.default.createElement('path', { d: 'M8.968,14.24 L6.12,14.24 C5.904,14.24 5.72,14.064 5.72,13.84 C5.72,13.616 5.904,13.44 6.12,13.44 L8.968,13.44 C9.184,13.44 9.368,13.616 9.368,13.84 C9.368,14.064 9.184,14.24 8.968,14.24', id: 'Fill-2100' }),
      _react2.default.createElement('path', { d: 'M3.568,17.096 L0.8,17.096 C0.36,17.096 1.13686838e-13,16.736 1.13686838e-13,16.296 L1.13686838e-13,1.496 C1.13686838e-13,1.048 0.36,0.696 0.8,0.696 L12.296,0.696 C12.736,0.696 13.096,1.048 13.096,1.496 L13.096,4.6 C13.096,5.04 12.736,5.4 12.296,5.4 C11.848,5.4 11.496,5.04 11.496,4.6 L11.496,2.296 L1.6,2.296 L1.6,15.496 L3.568,15.496 C4.008,15.496 4.368,15.848 4.368,16.296 C4.368,16.736 4.008,17.096 3.568,17.096', id: 'Fill-2101' }),
      _react2.default.createElement('path', { d: 'M8.896,3.168 L4.2,3.168 C3.32,3.168 2.616,2.456 2.616,1.584 C2.616,0.704 3.32,5.66213743e-14 4.2,5.66213743e-14 L8.896,5.66213743e-14 C9.768,5.66213743e-14 10.48,0.704 10.48,1.584 C10.48,2.456 9.768,3.168 8.896,3.168', id: 'Fill-2102' })
    )
  );
};

IconCopy.propTypes = {
  color: _propTypes2.default.string
};

IconCopy.defaultProps = {
  color: _colors2.default.icons
};

IconCopy.displayName = 'IconCopy';

exports.default = IconCopy;
module.exports = exports.default;